import CouponNotificationCard from './CouponNotificationCard';
import './CouponNotificationCard.css';

export default CouponNotificationCard;



// WEBPACK FOOTER //
// ./src/pages/Campaigns/components/CampaignCards/CouponNotificationCard/index.js